export default "__VITE_ASSET__B8KRcqU5__"